var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Scene10'),_c('Scene11'),_c('Scene12')],1)}
var staticRenderFns = []

export { render, staticRenderFns }